import { NgModule } from '@angular/core';
import { QrAttendanceComponent } from './qr-attendance.component';
import { QrAttendanceRoutingModule } from './qr-attendance-routing.module';
import { PrimengModule } from 'app/shared/modules/primeng.module';
import { FuseSharedModule } from '@fuse/shared.module';

@NgModule({
  declarations: [
    QrAttendanceComponent
  ],
  imports: [
    QrAttendanceRoutingModule,
    FuseSharedModule,
    PrimengModule,
  ]
})
export class QrAttendanceModule { }
